/* R7: cart-relative watch UI; reuses the main product's existing watch handler. */
(function(){
  'use strict';
  if(window.lpSourceWatchUI)return;
  window.lpSourceWatchUI=true;
  const states=new Map();
  let timer;
  const setVisible=(element,visible)=>{
    if(!element)return;
    element.hidden=!visible;
    element.style.display=visible?'':'none';
    if(visible)element.removeAttribute('aria-hidden');else element.setAttribute('aria-hidden','true');
  };
  async function refreshMain(island){
    const sid=island.id.slice('cmp-data-'.length);
    const form=document.getElementById('cmp-product-form-'+sid);
    const id=Number(form?.querySelector('[name="id"]')?.value);
    const atc=document.getElementById('cmp-atc-'+sid);
    const watch=document.getElementById('cmp-bevaka-'+sid);
    if(!form || !id || !atc || !watch || !window.lpSourceCart?.availability)return;
    let data;try{data=JSON.parse(island.textContent);}catch(_){return;}
    const variant=data.variants?.find(v=>Number(v.id)===id);
    if(!variant)return;
    let state=states.get(sid);
    if(!state){state={revision:0,owned:false,id};states.set(sid,state);}
    if(state.id!==id){state.owned=false;state.id=id;}
    const revision=++state.revision;
    // Keep the theme's invitation to choose a motif until the customer chooses.
    if(document.getElementById('cmp-choose-hint-'+sid))return;
    const match=data.product?.url?.match(/\/products\/([^/?#]+)/);
    const handle=match?decodeURIComponent(match[1]):undefined;
    let result;try{result=await window.lpSourceCart.availability(id,handle);}catch(_){return;}
    if(revision!==state.revision || Number(form.querySelector('[name="id"]')?.value)!==id || !result.known)return;
    const quantity=document.getElementById('cmp-qty-wrap-'+sid);
    const slot=document.getElementById('cmp-cta-slot-'+sid);
    if(result.watch){
      state.owned=true;
      setVisible(atc,false);setVisible(watch,true);setVisible(quantity,false);
      if(slot)slot.style.gridColumn='1 / -1';
      watch.dataset.lpCartWatch='true';
    }else if(state.owned && variant.available){
      state.owned=false;
      setVisible(atc,true);setVisible(watch,false);setVisible(quantity,true);
      atc.disabled=false;atc.removeAttribute('aria-disabled');
      if(slot)slot.style.gridColumn='';
      delete watch.dataset.lpCartWatch;
    }
  }
  function refresh(){
    if(window.LP_SOURCE_TRACKING_ENABLED!==true)return;
    document.querySelectorAll('script[id^="cmp-data-"]').forEach(refreshMain);
  }
  function schedule(){clearTimeout(timer);timer=setTimeout(refresh,100);}
  ['lp:source-cart-settled','claude:cart:update','cart:updated','shopify:section:load'].forEach(name=>document.addEventListener(name,schedule));
  document.addEventListener('change',event=>{if(event.target.closest('[id^="cmp-product-form-"], [id^="cmp-"]'))schedule();},true);
  document.addEventListener('click',event=>{if(event.target.closest('[id^="cmp-"]'))schedule();},true);
  document.addEventListener('submit',event=>{
    const sid=event.target.id?.replace(/^cmp-product-form-/,'');
    const state=states.get(sid);
    if(state?.owned && Number(event.target.querySelector('[name="id"]')?.value)===state.id){
      event.preventDefault();event.stopImmediatePropagation();
      document.getElementById('cmp-bevaka-'+sid)?.click();
    }
  },true);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',schedule,{once:true});else schedule();
})();
